import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MenuComponent } from './menu.component';
import { MenuItemComponent } from './menu-item.component';
import { MenuGroupComponent } from './menu-group.component';
import { SubMenuComponent } from './submenu.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    declarations: [
        MenuComponent,
        MenuItemComponent,
        MenuGroupComponent,
        SubMenuComponent
    ],
    exports: [
        MenuComponent,
        MenuItemComponent,
        MenuGroupComponent,
        SubMenuComponent
    ],
    providers: [],
})
export class MenuModule { }
